// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__sIHdx","footer":"ModalInfo_footer__15NX7"};